<div class="container">
  <ng-content></ng-content>
</div>

<div (click)="toggleExpanded()" class="minimize">
  <p>Minimise</p>
  <mat-icon>unfold_more</mat-icon>
</div>
